export function dispatchContactSyncEvents(eventApi, res, systemApi) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    console.log('[contact] contactNotify send', res);
    const contactNotifyData = {
        eventName: 'contactNotify',
        eventStrData: 'notify',
        eventData: res,
        eventSeq: 0,
        noLog: true,
        _account: res._account || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id),
    };
    if (((_b = res.syncStatus) === null || _b === void 0 ? void 0 : _b.org) || ((_c = res.syncStatus) === null || _c === void 0 ? void 0 : _c.team) || ((_d = res.syncStatus) === null || _d === void 0 ? void 0 : _d.personalOrg)) {
        eventApi.sendSysEvent(Object.assign(Object.assign({}, contactNotifyData), { eventName: 'contactOrgNotify' }));
    }
    eventApi.sendSysEvent(contactNotifyData);
    if (((_e = res.syncStatus) === null || _e === void 0 ? void 0 : _e.enterprise) || ((_f = res.syncStatus) === null || _f === void 0 ? void 0 : _f.personal) || ((_g = res.syncStatus) === null || _g === void 0 ? void 0 : _g.customer) || ((_h = res.syncStatus) === null || _h === void 0 ? void 0 : _h.clue) || res.isAll) {
        eventApi.sendSysEvent(Object.assign(Object.assign({}, contactNotifyData), { eventName: 'contactAccountNotify' }));
    }
}
